"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initHubspot = initHubspot;
const SCRIPT_ID = 'hs-script-loader';
function isDNTEnabled() {
    return !!(window.doNotTrack === '1' ||
        navigator.doNotTrack === 'yes' ||
        navigator.doNotTrack === '1');
}
function initHubspot({ portalId, respectDNT = true }) {
    const trimmedPortalId = portalId.trim();
    if (!trimmedPortalId) {
        window.console?.warn?.('HubSpot portalId is missing or empty. Skipping initialization.');
        return;
    }
    if (document.getElementById(SCRIPT_ID)) {
        window.console?.warn?.('HubSpot script already initialized. Skipping duplicate initialization.');
        return;
    }
    const hsq = (window._hsq = window._hsq || []);
    hsq.push(['setPath', window.location.pathname + window.location.search + window.location.hash]);
    if (respectDNT && isDNTEnabled()) {
        hsq.push(['doNotTrack']);
    }
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.defer = true;
    script.src = `//js.hs-scripts.com/${trimmedPortalId}.js`;
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
    }
    else {
        document.head.appendChild(script);
    }
}
